import React from 'react';
import {
  Border,
  Box,
  Overlay,
  Padding,
  Queue,
  Stack,
  Text,
  Quote,
} from '../../components';

export const CoreValuesMissionMobile = () => {
  return (
    <>
      <Queue>
        <Box ratio={0.9} backgroundImage="images/about-glossier-1.jpg" />
        <Box ratio={0.9} backgroundImage="images/about-glossier-2.jpg" />
      </Queue>

      <Overlay relative top={-15}>
        <Padding size={[0, 5]}>
          <Border borderSize={[2]} borderRole="white" radius="small">
            <Padding size={[5]} backgroundRole="white">
              <Stack size={4}>
                <Quote textType="quote" align="left">
                  Glossier is giving voice through beauty as a
                  direct-to-consumer company that leverages the power of
                  personal narrative to own the beauty conversation on the
                  internet.
                </Quote>

                <Text textType="primary2" align="left">
                  As a brand that puts skin first, Glossier is redefining the
                  beauty industry by fusing the insights of our community with
                  our beauty-editor expertise (rooted in Glossier’s successful
                  publication Into The Gloss) to create a line of intuitive,
                  enjoyable products that work hard for you (not the other way
                  around). Together, we’re bringing the experience of shopping
                  for (and talking about) beauty into the future.
                </Text>
              </Stack>
            </Padding>
          </Border>
        </Padding>
      </Overlay>
    </>
  );
};
